export default __webpack_public_path__ + "static/media/0070.cec0cb20.png";